var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrowBack = function SvgArrowBack(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 5.865 10.258",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.097 5.131.215 9.009a.73.73 0 0 0 0 1.035.74.74 0 0 0 1.038 0L5.651 5.65a.73.73 0 0 0 .022-1.011L1.257.214A.733.733 0 0 0 .218 1.249Z",
    className: "arrow_back_svg__cls-1",
    "data-name": "Icon ionic-ios-arrow-down"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrowBack);
export default ForwardRef;